<!--<div *ngIf="error" class="alert alert-danger">{{error}}</div>-->
<link href="https://fonts.googleapis.com/css2?family=Dancing+Script&display=swap" rel="stylesheet">

<header class="masthead">
    <!--flying birds-->
    <div class="bird-container bird-container--one">
        <div class="bird bird--one"></div>
    </div>
    <div class="bird-container bird-container--two">
        <div class="bird bird--two"></div>
    </div>   
    <div class="bird-container bird-container--three">
        <div class="bird bird--three"></div>
    </div>
    <div class="bird-container bird-container--four">
        <div class="bird bird--four"></div>
	</div>

    <div class="container d-flex h-100 align-items-center">
        <div class="mx-auto text-center">
        <br>
        <h1 class="mx-auto my-0 text-uppercase">REGISTER</h1> 
        <br>
        <p> For testing API, Authentication, JWT token feature purpose only :)
        
        </p>
        <br>
        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label for="firstName" style="color: white">First Name</label>
                <input type="text" formControlName="firstName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" />
                
                <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                    <div *ngIf="f.firstName.errors.required">First Name is required</div>
                </div>
            </div>
            <div class="form-group">
                <label for="lastName" style="color: white">Last Name</label>
                <input type="text" formControlName="lastName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" />
                <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                    <div *ngIf="f.lastName.errors.required">Last Name is required</div>
                </div>
            </div>
            <div class="form-group">
                <label for="username" style="color: white">Username</label>
                <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
                <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                    <div *ngIf="f.username.errors.required">Username is required</div>
                </div>
            </div>
            <div class="form-group">
                <label for="password" style="color: white">Password</label>
                <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required">Password is required</div>
                    <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div>
                </div>
            </div>
            <div class="form-group">
                <button [disabled]="loading" class="btn btn-primary" style="background-color:#A3E4D7">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Register
                </button>
                <a routerLink="/login" class="btn btn-link" style="color:#A3E4D7">Cancel</a>
            </div>
        </form>
        </div>
    </div>
</header>
